import React from "react";
import Avatar from "../images/Avatar.png";

function LandingPage() {
  return (
    <section className="flex justify-center items-center w-full h-dvh">
      <div className="px-2 text-center">
        <img className="rounded-full mx-auto" src={Avatar} alt="Avatar" />
        <h1 className="text-8xl font-bold text-yellow-200 font-heading">
          Ishan Saxena Games
        </h1>
        <h4 className="text-2xl">(I make games for fun)</h4>
      </div>
    </section>
  );
}

export default LandingPage;
